var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tabs',[_c('v-tab',[_vm._v("Products")]),_c('v-tab',[_vm._v("Product Categories")]),_c('v-tab-item',[_c('products',{attrs:{"canAddProducts":_vm.canAddProducts}})],1),_c('v-tab-item',[_c('product-categories')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }